import React from 'react'
import InterviewQuestionCard from './InterviewQuestionCard';

const InterviewQuestionTab = () => {

    const sampleData = [
        {
            id: "Q1",
            time: "02:15",
            score: "4/4",
            question: "Tell me about your experience with Meta advertising campaigns.",
            studentResponse:
                "I managed several Meta campaigns during my internship at XYZ Agency. We worked with e-commerce clients and achieved an average ROAS of 4.2x across 15 campaigns. I was responsible for audience research, ad creative testing, and budget optimization.",
            aiFollowUps: [
                "Can you walk me through your process for audience research?",
                "What specific metrics did you track beyond ROAS?",
            ],
            aiAssessment:
                "Strong response with specific metrics and clear responsibilities. Shows practical experience.",
            competencies: ["Technical Skills", "Data Orientation", "Communication"],
            adminNotes: "",
        },
        {
            id: "Q2",
            time: "08:30",
            score: "3/4",
            question: "Describe a challenging campaign you worked on and how you overcame the obstacles.",
            studentResponse:
                "We had a client whose CPM increased by 60% during Q4. I analyzed the data and found that our target audience was too broad. I created more specific audience segments and implemented a creative rotation strategy.",
            aiFollowUps: [
                "What was the outcome after implementing these changes?",
                "How did you measure the success of your audience segmentation?",
            ],
            aiAssessment:
                "Good proglem identification and solution approach, but lacks specific outcome metrics.",
            competencies: ["Problem Solving", "Learning Agility", "Data Orientation"],
            adminNotes: "",
        }
    ];



    return (
    <>

    {sampleData.map((item) => (
        <InterviewQuestionCard data={item} key={item.id} />
    ))}
    </>)
  
}

export default InterviewQuestionTab;
